import { Metrics } from "../models/Metrics";
import { Box, ErrorIcon, ExclamationIcon } from "@platform/style";
import * as React from "react";
import { MetricsCardConfiguration } from "../models/MetricsCardConfiguration";
import { Dispatch, SetStateAction } from "react";

const formatContentValue = (contentValue: number, isLoaded: boolean) => {
  if (!isLoaded) {
    return "...";
  }
  return Intl.NumberFormat("en-US", {
    notation: "compact",
    maximumFractionDigits: 1,
  }).format(contentValue || 0);
};

export function getMetricsCardConfigData(
  typeOfWorkItemPage: string,
  metrics: Metrics,
  isLoaded: boolean,
  theme: any
) {
  return [
    {
      borderColor: "lightgrey",
      count: 3,
      content:
        typeOfWorkItemPage == "Active"
          ? [
              {
                caption: "Total Work",

                value: formatContentValue(metrics.totalWorkCount ?? 0, isLoaded),
              },
              {
                caption: "Assigned",
                value: formatContentValue(metrics.assignedCount ?? 0, isLoaded),
              },
              {
                caption: "Unassigned",
                value: formatContentValue(metrics.unAssignedCount ?? 0, isLoaded),
              },
            ]
          : [
              {
                caption: "Total Work",
                value: formatContentValue(metrics.totalWorkCount ?? 0, isLoaded),
              },
              {
                caption: "Completed",
                value: formatContentValue(metrics.completedCount ?? 0, isLoaded),
              },
              {
                caption: "Cancelled",
                value: formatContentValue(metrics.cancelledCount ?? 0, isLoaded),
              },
            ],
      bgColor: "none",
      icon: <></>,
    },
    {
      borderColor: theme.palette.error.main,
      count: typeOfWorkItemPage == "Active" ? 1 : 0,
      content:
        typeOfWorkItemPage == "Active"
          ? [
              {
                caption: "Past Due",

                value: formatContentValue(metrics.targetPastDueDateCount ?? 0, isLoaded),
              },
            ]
          : [],
      bgColor: theme.palette.error.main + "0D",
      icon: (
        <Box
          sx={{
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: "error.main",
          }}
        >
          <ErrorIcon fontSize={"small"} />
        </Box>
      ),
    },
    {
      borderColor: theme.palette.warning.main,
      count: typeOfWorkItemPage == "Active" ? 1 : 0,
      content:
        typeOfWorkItemPage == "Active"
          ? [
              {
                caption: "Due Today",
                value: formatContentValue(metrics.dueTodayCount ?? 0, isLoaded),
              },
            ]
          : [],
      bgColor: theme.palette.warning.main + "0D",
      icon: (
        <Box
          sx={{
            position: "absolute",
            right: theme.spacing(1),
            top: theme.spacing(1),
            color: "warning.main",
            fontSize: "large",
          }}
        >
          <ExclamationIcon />
        </Box>
      ),
    },
  ] as MetricsCardConfiguration[];
}

export function updateMetrics(metrics: Metrics, setMetrics: Dispatch<SetStateAction<Metrics>>) {
  setMetrics({
    assignedCount: metrics.assignedCount,
    targetPastDueDateCount: metrics.targetPastDueDateCount,
    dueTodayCount: metrics.dueTodayCount,
    completedCount: metrics.completedCount,
    unAssignedCount: metrics.unAssignedCount,
    cancelledCount: metrics.cancelledCount,
    totalWorkCount: metrics.totalWorkCount,
  });
}
